module.exports = __webpack_public_path__ + "static/media/STod2.de54f370.svg";